var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "main",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#4D4D4D;stroke:#000000;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.54,16.77"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.84,11.71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.16,17.66c-0.42-0.76-0.97-1.39-1.66-1.89c-0.65-0.47-1.35-0.86-2.1-1.17c-0.61-2.12-2.54-3.69-4.86-3.69 c-1,0-1.92,0.3-2.7,0.79c-0.11-0.1-0.23-0.19-0.31-0.29c-0.46-0.53-0.69-1.17-0.69-1.91c0-0.69,0.33-1.34,1-1.93 c0.67-0.59,1.65-0.89,2.95-0.89c0.47,0,0.97,0.07,1.5,0.21s1.03,0.3,1.48,0.47c0.45,0.18,0.78,0.33,0.98,0.46 c0.13,0.09,0.27,0.2,0.42,0.34c0.15,0.14,0.25,0.3,0.3,0.46l0.91,2.88h2.11v-6.5c-0.65-0.16-1.4-0.32-2.26-0.47 c-0.86-0.15-1.76-0.29-2.7-0.39c-0.94-0.11-1.6-0.23-2.51-0.23l0.09-2.32l-2.25-0.03l-0.21,2.59c-0.91,0.14-1.46,0.34-2.29,0.69 c-1.36,0.58-2.46,1.4-3.3,2.45c-0.84,1.05-1.26,2.29-1.26,3.7c0,1.53,0.4,2.79,1.2,3.79c0.66,0.82,1.5,1.47,2.51,1.96 c0.37,2.44,2.46,4.31,5,4.31c1.19,0,2.28-0.43,3.14-1.12c0.02,0.02,0.05,0.03,0.06,0.05c0.54,0.43,0.82,1.09,0.82,2 c0,0.99-0.43,1.79-1.29,2.39c-0.86,0.6-1.97,0.9-3.34,0.9c-0.49,0-1.05-0.08-1.66-0.26c-0.62-0.17-1.21-0.38-1.78-0.63 c-0.57-0.25-1.04-0.49-1.42-0.73c-0.12-0.08-0.25-0.2-0.41-0.34c-0.15-0.14-0.26-0.3-0.31-0.47l-0.94-3.06H7.29l0.1,6.74 c0.84,0.23,1.75,0.46,2.73,0.69c0.98,0.22,1.95,0.41,2.92,0.55c0.65,0.1,1.08,0.15,1.65,0.18l0.2,2.45l2.25-0.03l-0.09-2.43 c1.82-0.1,3.09-0.42,4.34-1.01c1.5-0.7,2.61-1.63,3.34-2.78c0.72-1.15,1.09-2.38,1.09-3.7C25.8,19.36,25.59,18.43,25.16,17.66z  M16.54,18.97c-1.64,0-2.97-1.33-2.97-2.97c0-1.64,1.33-2.97,2.97-2.97s2.97,1.33,2.97,2.97C19.51,17.64,18.18,18.97,16.54,18.97z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrency);
export default __webpack_public_path__ + "static/media/currency.e3505e0fd4ba18b093d2473fcafc35f7.svg";
export { ForwardRef as ReactComponent };